import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";
import { activeMenuPath } from "@/lib/navigation-active";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useLayout } from "./context";

export function HeaderBreadcrumbs() {
  const t = useTranslations("layout30");
  const pathname = usePathname();
  const { settings } = useLayout();
  const items = settings.sectionMenu.flatMap((group) => group.children ?? []);
  const activePath = activeMenuPath(
    items.map((item) => item.path),
    pathname,
  );
  const active = items.find((item) => item.path === activePath);

  if (!active?.title) return null;
  return (
    <div
      data-slot="header-breadcrumbs"
      data-debug-source="components/layouts/layout-30/components/header-breadcrumbs.tsx"
      className="hidden min-w-0 items-center overflow-hidden lg:flex"
    >
      <Breadcrumb aria-label={t("breadcrumb")} className="min-w-0">
        <BreadcrumbList className="min-w-0 flex-nowrap gap-1 whitespace-nowrap text-zinc-400">
          <BreadcrumbSeparator className="shrink-0 px-1.5 text-sm text-zinc-500">
            {"/"}
          </BreadcrumbSeparator>
          <BreadcrumbItem className="min-w-0">
            <BreadcrumbPage className="block max-w-64 truncate text-zinc-100">
              {t(active.title as Parameters<typeof t>[0])}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}
